import VacancyCandidatesCountByStatus from '@/orm/models/Vacancy/VacancyCandidatesCountByStatus';
import { computed } from '@vue/composition-api';

export default function useVacancies() {
  const countCandidatesByStatus = computed(() => VacancyCandidatesCountByStatus.query().get());

  async function getCountCandidatesByStatus(id, search = '') {
    return VacancyCandidatesCountByStatus.api().fetchCountCandidatesByStatus(id, search);
  }

  return {
    getCountCandidatesByStatus,
    countCandidatesByStatus,
  };
}
